module.exports = __webpack_public_path__ + "static/Calibre-RegularItalic-3a445970c7bcd6b102ac6bd60178b0bc.woff";